

import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_109_2_Heading";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_109_2_Heading__root","heading-h1":"wds_1_109_2_StylableTypography__heading-h1","heading-h2":"wds_1_109_2_StylableTypography__heading-h2","heading-h3":"wds_1_109_2_StylableTypography__heading-h3","heading-h4":"wds_1_109_2_StylableTypography__heading-h4","heading-h5":"wds_1_109_2_StylableTypography__heading-h5","heading-h6":"wds_1_109_2_StylableTypography__heading-h6","heading-xl":"wds_1_109_2_StylableTypography__heading-xl","heading-l":"wds_1_109_2_StylableTypography__heading-l","heading-m":"wds_1_109_2_StylableTypography__heading-m","heading-s":"wds_1_109_2_StylableTypography__heading-s","heading-t":"wds_1_109_2_StylableTypography__heading-t","heading-xt":"wds_1_109_2_StylableTypography__heading-xt"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-color-text-standard-secondary":"--wds-color-text-standard-secondary","wds-font-letter-spacing-heading-5":"--wds-font-letter-spacing-heading-5","wds-font-letter-spacing-heading-6":"--wds-font-letter-spacing-heading-6"}; 




